// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nvPh","top":"styles_top__3SXoP"};